import { IPolygonLayer } from '../components/features/Map/Layer/DatasetZoneLayer';
import { DownloadInfoItem } from './analytics';
import { TLandRelation } from './api';
import { IBestDataset } from './search';

export interface MarkerStore {
  markers: IMarker[];
  activeMarkerId: string | null;
  activeMarker: () => IMarker | null;
  isAddMarkerMode: boolean;
  deleteMarker: (markerId: string) => void;
  addMarker: (marker: IMarker) => void;
  updateMarker: (markerId: string, updates: Partial<IMarker>) => void;
  setActiveMarker: (markerId: string | null) => void;
  setAddMarkerMode: (status: boolean) => void;
  setActiveKey: (markerId: string, metadataType: DatasetType) => void;
  setResetMarker: () => void;
  setWaterDepth: (
    markerId: string,
    panelName: string,
    value: string | number | null
  ) => void;
  setCellSize: (
    markerId: string,
    panelName: string,
    value: string | number | null
  ) => void;
  setLandRelation: (
    markerId: string,
    panelName: string,
    value: TLandRelation | null
  ) => void;
  setDownloadPage: (
    markerId: string,
    panelName: string,
    value: DownloadInfoItem
  ) => void;
  setDatasetOffline: (
    markerId: string,
    panelName: string,
    value: boolean
  ) => void;
  setDatasetReport: (
    markerId: string,
    panelName: string,
    value: boolean
  ) => void;
  setActiveDatasetKey: (
    markerId: string,
    datasetKey: DatasetType,
    newActiveDataset: string
  ) => void;
  setActivePanel: (markerId: string, datasetKey: DatasetType | string) => void;
}

export interface IMarker {
  id: string;
  label: string;
  coordinates: number[];
  active: boolean;
  depth: number;
  dataset: string;
  allDataset: IBestDataset;
  downloadPage: DownloadInfoItem[];
  shapeFiles: overlay[];
  surfaceMaps: surfaceMaps;
  coordinatesToMove?: number[];
  fwePointName?: string;
  insituPointName?: string;
  activeDatasetKey?: DatasetType;
  activePanel?: DatasetType | string;
  waterDepth?: { [key: string]: string | number };
  cellSize?: { [key: string]: string | number };
  landRelation?: { [key: string]: TLandRelation | '-' };
  isDatasetOffline?: { [key: string]: boolean };
  isDatasetHasReport?: { [key: string]: boolean };
}

export interface overlay {
  Level1: string;
  Level2: string;
  Unit: string;
  Path: string;
  IsDefault: boolean;
  IsDisplay: boolean;
  LegendColor: [string];
  data: IPolygonLayer[] | undefined;
}

export interface surfaceMaps {
  overlays: overlay[];
  categories: surfaceMapCategory[];
  selectedLevel1: string;
  selectedLevel2: string;
}
export interface surfaceMapCategory {
  name: string;
  IsDisplay: boolean;
}

export interface ChangePointLocationParams {
  coordinates: number[];
  forceChange?: boolean;
  insituPointName?: string;
}

export enum DatasetType {
  SW = 'SW',
  Wind = 'Wind',
  HD = 'HD',
  Other = 'Other',
}
